import axios from "axios";

const instance = axios.create({
    withCredentials: true,
});

instance.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
instance.defaults.withCredentials = true;
instance.defaults.withXSRFToken = true;

// Load token from storage on init (if any)
try {
    const token = localStorage.getItem('auth_token');
    if (token) {
        instance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }
} catch (_) {
    // ignore storage errors
}

export default instance;